// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-up';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 16V3M3 9.067 9 3l6 6.067'
  />
);

export const viewBox = '0 0 18 18';
